import styled from 'libs/styled';

const Circle = styled('circle')``;

export default Circle;
